import React from 'react';
import styled from 'styled-components';

function ResumeItem({ year, title, subTitle, text }) {
  return (
    <ResumeItemStyled>
      <div className="left-content">
        <p>{year}</p>
      </div>
      <div className="right-content">
        <h5>{title}</h5>
        <h6>{subTitle}</h6>
        <p>{text}</p>
      </div>
    </ResumeItemStyled>
  );
}

const ResumeItemStyled = styled.div`
  display: flex;
  @media screen and (max-width: 521px) {
    p,
    h6 {
      font-size: 80%;
    }
  }
  &:not(:last-child) {
    padding-bottom: 3rem;
  }
  .left-content {
    width: 20%;
    padding-left: 20px;
    position: relative;
    @media screen and (max-width: 521px) {
      width: 33%;
    }
    &::before {
      content: '';
      position: absolute;
      left: -10px;
      top: 12px;
      height: 15px;
      width: 15px;
      border-radius: 50%;
      border: 2px solid var(--border-color);
      background-color: var(--background-dark-color);
    }
    p {
      display: inline-block;
      padding: 11px;
    }
  }
  .right-content {
    padding-left: 5rem;
    position: relative;
    width: 100%;
    @media screen and (max-width: 521px) {
      padding-left: 1rem;
    }
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 21px;
      height: 2px;
      width: 3rem;
      background-color: var(--border-color);
      @media screen and (max-width: 521px) {
        width: 1rem;
      }
    }
    h5 {
      color: var(--primary-color);
      font-size: 2rem;
      padding-bottom: 0.4rem;
      @media screen and (max-width: 521px) {
        font-size: 1.5rem;
      }
    }
    h6 {
      padding-bottom: 0.6rem;
      font-size: 1.2rem;
    }
  }
`;
export default ResumeItem;
